import type { H3Event } from 'h3';
import type { LOCALE_CODE } from '~~/lib/ContentfulService';
import type { PageTeaserMeta } from '~/types/PageTeaserMeta';

const REQUEST_PAGE_TEASER_META_KEY = 'pageTeaserMetaByCacheKey';

type RequestScopedPageTeaserMetaStore = Record<string, PageTeaserMeta>;

function getStore(event: H3Event): RequestScopedPageTeaserMetaStore {
  if (!event.context[REQUEST_PAGE_TEASER_META_KEY]) {
    event.context[REQUEST_PAGE_TEASER_META_KEY] = {};
  }

  return event.context[
    REQUEST_PAGE_TEASER_META_KEY
  ] as RequestScopedPageTeaserMetaStore;
}

export function buildPageTeaserMetaCacheKey(
  locale: LOCALE_CODE | string,
  slug?: string,
  entryId?: string
): string {
  if (entryId) {
    return `id:${entryId}:${locale}`;
  }

  return `slug:${slug ?? ''}:${locale}`;
}

/**
 * Stores pre-computed page teaser meta on the current request. Used so
 * `/api/contentful` can strip teaser fields from `page` without exposing
 * `pageTeaserMeta` in the JSON response.
 */
export function setRequestScopedPageTeaserMeta(
  event: H3Event,
  cacheKey: string,
  meta: PageTeaserMeta
): void {
  getStore(event)[cacheKey] = meta;
}

/**
 * Returns teaser meta previously stored during `/api/contentful` in the same SSR request.
 */
export function getRequestScopedPageTeaserMeta(
  event: H3Event | undefined,
  cacheKey: string
): PageTeaserMeta | undefined {
  if (!event) {
    return undefined;
  }

  return getStore(event)[cacheKey];
}
